import * as React from 'react';
import { Text, View } from "../../components/Themed";

export default function PlaceholderScreen() {
    return <View style={{flex:1, justifyContent:'center', alignItems: 'center' }}>
        <Text>Placeholder</Text>
    </View>
}
